import axios from 'axios'
import { UrlApi, authMail, authPass } from '../Keys'
import { toast } from "react-toastify"
import moment from "moment"

const dataInicial = {
    comitesJurados: [],
    loadingComitesJurados: false,
    creacion: '',
    creacionId: ''
}

const LOADING_COMITES_JURADOS = 'LOADING_COMITES_JURADOS'
const COMITES_JURADOS = 'COMITES_JURADOS'
const COMITES_JURADOS_ERROR = 'COMITES_JURADOS_ERROR'

const CREAR_COMITE_EXITO = 'CREAR_COMITE_EXITO'
const CREAR_COMITE_ERROR = 'CREAR_COMITE_ERROR'

//Reducers
export default function comitesReducer(state = dataInicial, action) {
    switch (action.type) {
        case COMITES_JURADOS:
            return { ...state, comitesJurados: action.payload, loadingComitesJurados: action.loadingComitesJurados }
        case LOADING_COMITES_JURADOS:
            return { ...state, loadingComitesJurados: action.loadingComitesJurados }
        case CREAR_COMITE_EXITO:
            return { ...state, creacionId: action.payload, creacion: action.creacion }
        default:
            return { ...state }
    }
}

export const comitesYjurados = (token, usuarioPortal) => async (dispatch) => {
    dispatch({
        type: LOADING_COMITES_JURADOS,
        loadingComitesJurados: true
    })

    try {
        var entidad = "new_participacionencomitesyjuradoses"
        var fetch =
            "<entity name='new_participacionencomitesyjurados'>" +
            "<attribute name='new_tipodeevaluacin'/>" +
            "<attribute name='new_institucinconvocante'/>" +
            "<attribute name='new_lugar'/>" +
            "<attribute name='new_fecha'/>" +
            "<attribute name='new_participacionencomitesyjuradosid'/>" +
            "<order attribute='new_fecha' descending='true'/>" +
            "<filter type='and'>" +
            "<condition attribute='statecode' operator='eq' value='0'/>" +
            "</filter>" +
            "<link-entity name='new_empleado' from='new_empleadoid' to='new_empleado' link-type='inner' alias='ad'>" +
            "<filter type='and'>" +
            "<condition attribute='new_correoelectronico' operator='like' value='" + usuarioPortal + "'/>" +
            "</filter>" +
            "</link-entity>" +
            "</entity>";

        const response = await axios.post(`${UrlApi}api/consultafetch`,
            {
                "entidad": entidad,
                "fetch": fetch
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        dispatch({
            type: COMITES_JURADOS,
            payload: response.data,
            loadingComitesJurados: false
        })
    }
    catch (error) {
        dispatch({
            type: COMITES_JURADOS_ERROR,
            loadingComitesJurados: false
        })
    }
}

export const crearComite = (empleado, objeto, token) => async (dispatch) => {
    const { new_institucinconvocante, new_tipodeevaluacin, new_lugar, new_fecha } = objeto;

    var fecha = new_fecha
    return toast.promise(
        new Promise((resolve, reject) => {
            axios.post(
                `${UrlApi}api/hrfactors/participacionencomites`,
                {
                    "new_institucinconvocante": new_institucinconvocante.value,
                    "new_tipodeevaluacin": new_tipodeevaluacin,
                    "new_lugar": new_lugar,
                    "new_fecha": moment(fecha).format('YYYY-MM-DD'),
                    "new_empleado": empleado
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                })
                .then((response) => {
                    dispatch({
                        type: CREAR_COMITE_EXITO,
                        payload: response.data,
                        creacion: "EXITO",
                    });
                    resolve(response.data);
                })
                .catch((error) => {
                    console.log(error);

                    dispatch({
                        type: CREAR_COMITE_ERROR,
                        creacion: "ERROR",
                    });
                    reject(error);
                });
        }),
        {
            pending: "Procesando...",
            success: "Participación creada con éxito!",
            error: {
                render({ data }) {
                    return `${data}`;
                },
            },
        },
        {
            theme: "dark",
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        }
    )
};